import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable no-param-reassign */
import { debounce, isEmpty } from "lodash-es";
import { Component, Mixins, Watch } from 'vue-property-decorator';
import devToolMixin, { lsKeysForDevTool } from '../../../util/devToolMixin';
import SearchableJsonView from '../../../util/SearchableJsonView';
import { startMouseMove } from "../../../../../../lib/utils";
// const displayTabs = ['data', 'state', 'parentScope'];
let DatasourceDrawer = class DatasourceDrawer extends Mixins(devToolMixin) {
  constructor() {
    super(...arguments);
    this.extraHeight = 0;
    this.height = this.defaultHeight;
    this.tab = 'data';
    this.currentRenderer = null;
    this.dsSearchInput = '';
  }
  getDisplayDatasource(renderer) {
    const displayTabs = this.getDisplayTabs(renderer === null || renderer === void 0 ? void 0 : renderer.ucDataSources);
    return displayTabs.reduce((prev, cur) => {
      var _renderer$ucDataSourc, _renderer$ucDataSourc2;
      switch (cur) {
        case '$app':
          prev[cur] = renderer;
          break;
        case 'wContext':
          // eslint-disable-next-line no-case-declarations
          const fields = renderer === null || renderer === void 0 || (_renderer$ucDataSourc = renderer.ucDataSources) === null || _renderer$ucDataSourc === void 0 || (_renderer$ucDataSourc = _renderer$ucDataSourc.wContext) === null || _renderer$ucDataSourc === void 0 || (_renderer$ucDataSourc = _renderer$ucDataSourc.schema) === null || _renderer$ucDataSourc === void 0 || (_renderer$ucDataSourc = _renderer$ucDataSourc.fields) === null || _renderer$ucDataSourc === void 0 ? void 0 : _renderer$ucDataSourc.map(field => field.id).filter(field => field !== 'lessCode' && field !== 'config'); // lesscode竟然是一个vue实例...
          prev[cur] = fields.reduce((prev, cur) => {
            var _renderer$wContext;
            prev[cur] = renderer === null || renderer === void 0 || (_renderer$wContext = renderer.wContext) === null || _renderer$wContext === void 0 ? void 0 : _renderer$wContext[cur];
            return prev;
          }, {});
          break;
        default:
          // eslint-disable-next-line no-param-reassign
          prev[cur] = renderer === null || renderer === void 0 || (_renderer$ucDataSourc2 = renderer.ucDataSources) === null || _renderer$ucDataSourc2 === void 0 || (_renderer$ucDataSourc2 = _renderer$ucDataSourc2[cur]) === null || _renderer$ucDataSourc2 === void 0 ? void 0 : _renderer$ucDataSourc2.instance;
      }
      return prev;
    }, {});
  }
  get parentScopeDataSource() {
    var _this$currentRenderer;
    if (this.currentRenderer && (_this$currentRenderer = this.currentRenderer) !== null && _this$currentRenderer !== void 0 && _this$currentRenderer.parentScope) {
      return this.getDisplayDatasource(this.currentRenderer.parentScope);
    }
    return null;
  }
  get currentScopeDataSource() {
    if (!isEmpty(this.currentScope)) {
      this.currentRenderer = this.currentScope.list[this.currentScope.index];
    } else {
      var _this$uc;
      this.currentRenderer = (_this$uc = this.uc) === null || _this$uc === void 0 ? void 0 : _this$uc.renderer;
    }
    return this.getDisplayDatasource(this.currentRenderer);
  }
  getDisplayTabs(datasource) {
    // wContext 和 $app 一直是undefined
    return Object.keys(datasource || {}).filter(key => {
      var _datasource$key;
      return !((_datasource$key = datasource[key]) !== null && _datasource$key !== void 0 && (_datasource$key = _datasource$key.schema) !== null && _datasource$key !== void 0 && _datasource$key.hidden);
    });
  }
  startResize(event) {
    const o = this.extraHeight;
    this.height = this.getTempHeight();
    startMouseMove({
      initialEvent: event,
      onMove: ({
        deltaY
      }) => {
        this.extraHeight = o - deltaY;
      },
      onEnd: () => {
        this.height = Math.min(this.height + this.extraHeight, this.parentHeight - 120);
        this.extraHeight = 0;
      }
    });
  }
  get parentHeight() {
    var _this$$parent;
    return ((_this$$parent = this.$parent) === null || _this$$parent === void 0 || (_this$$parent = _this$$parent.$parent) === null || _this$$parent === void 0 ? void 0 : _this$$parent.rightHeight) || 300;
  }
  handleHeightChange(val) {
    this.setHeight(val)();
  }
  setHeight(height) {
    return debounce(() => {
      localStorage.setItem(this.localStorageKey, height);
    }, 200);
  }
  get style() {
    const ans = {
      height: 'auto'
    };
    const {
      parentHeight
    } = this;
    if (this.dataSourceDrawerOpen) {
      let height;
      if (this.extraHeight) {
        height = Math.min(this.height + this.extraHeight, parentHeight - 120);
      } else {
        height = Math.min(this.height, this.parentHeight - 120);
      }
      ans.height = `${height}px`;
    }
    return ans;
  }
  get localStorageKey() {
    return lsKeysForDevTool.DS_PANEL_HEIGHT;
  }
  get defaultHeight() {
    return +(localStorage.getItem(this.localStorageKey) || (this.parentHeight || 600) / 2);
  }
  getTempHeight() {
    var _this$$refs$dsContent;
    return ((_this$$refs$dsContent = this.$refs.dsContent) === null || _this$$refs$dsContent === void 0 ? void 0 : _this$$refs$dsContent.offsetHeight) || -1;
  }
  get displayInfo() {
    var _this$currentRenderer2;
    const res = this.getDisplayTabs((_this$currentRenderer2 = this.currentRenderer) === null || _this$currentRenderer2 === void 0 ? void 0 : _this$currentRenderer2.ucDataSources).reduce((prev, cur) => {
      var _this$currentRenderer3, _this$currentRenderer4;
      // eslint-disable-next-line no-param-reassign
      prev[cur] = (((_this$currentRenderer3 = this.currentRenderer) === null || _this$currentRenderer3 === void 0 || (_this$currentRenderer3 = _this$currentRenderer3.ucDataSources) === null || _this$currentRenderer3 === void 0 || (_this$currentRenderer3 = _this$currentRenderer3[cur]) === null || _this$currentRenderer3 === void 0 || (_this$currentRenderer3 = _this$currentRenderer3.schema) === null || _this$currentRenderer3 === void 0 ? void 0 : _this$currentRenderer3.title) || ((_this$currentRenderer4 = this.currentRenderer) === null || _this$currentRenderer4 === void 0 || (_this$currentRenderer4 = _this$currentRenderer4.ucDataSources) === null || _this$currentRenderer4 === void 0 || (_this$currentRenderer4 = _this$currentRenderer4[cur]) === null || _this$currentRenderer4 === void 0 || (_this$currentRenderer4 = _this$currentRenderer4.schema) === null || _this$currentRenderer4 === void 0 ? void 0 : _this$currentRenderer4.id) || cur).trim();
      return prev;
    }, {});
    return res;
  }
  handleDisplayChange(val) {
    var _Object$keys;
    this.tab = ((_Object$keys = Object.keys(val)) === null || _Object$keys === void 0 ? void 0 : _Object$keys[0]) || 'data';
  }
  handleLog(data, path) {
    window.top[path] = data;
    this.messageOnDt(`请打开浏览器的控制台，使用 ${path} 展示当前数据`);
  }
  defaultScopeSlot(tab) {
    const h = this.$createElement;
    const scopedSlots = {
      scopedSlots: {
        default: val => h("span", {
          "class": "ucd-devTool-iconBtns"
        }, [h("a-tooltip", {
          "attrs": {
            "getPopupContainer": () => {
              var _this$windowRef;
              return ((_this$windowRef = this.windowRef) === null || _this$windowRef === void 0 ? void 0 : _this$windowRef.document.body) || window.document.body;
            }
          }
        }, [h("span", {
          "slot": "title"
        }, [" \u5728\u63A7\u5236\u53F0\u4E2D\u8C03\u8BD5 "]), h("a-icon", {
          "attrs": {
            "type": "bug"
          },
          "on": {
            "click": () => this.handleLog(val.value, '$data')
          }
        })]), h("a-tooltip", {
          "attrs": {
            "getPopupContainer": () => {
              var _this$windowRef2;
              return ((_this$windowRef2 = this.windowRef) === null || _this$windowRef2 === void 0 ? void 0 : _this$windowRef2.document.body) || window.document.body;
            }
          }
        }, [h("span", {
          "slot": "title"
        }, [" \u590D\u5236\u6570\u636E "]), h("a-icon", {
          "attrs": {
            "type": "database"
          },
          "on": {
            "click": () => {
              this.handleCopy(val.value);
              this.messageOnDt('数据源 数据 复制成功');
            }
          }
        })]), h("a-tooltip", {
          "attrs": {
            "getPopupContainer": () => {
              var _this$windowRef3;
              return ((_this$windowRef3 = this.windowRef) === null || _this$windowRef3 === void 0 ? void 0 : _this$windowRef3.document.body) || window.document.body;
            }
          }
        }, [h("span", {
          "slot": "title"
        }, [" \u590D\u5236\u8DEF\u5F84 "]), h("a-icon", {
          "attrs": {
            "type": "copy"
          },
          "on": {
            "click": () => {
              this.handleCopy(`${tab}${val.path}`);
              this.messageOnDt('数据源 路径 复制成功');
            }
          }
        })])])
      }
    };
    return scopedSlots;
  }
  get tabContent() {
    const h = this.$createElement;
    switch (this.tab) {
      case 'parentScope':
        return h(SearchableJsonView, _mergeJSXProps([{
          "attrs": {
            "value": this.parentScopeDataSource,
            "initKey": this.tab,
            "rootLevelKeys": [this.tab],
            "searchPlaceholder": "过滤数据",
            "searchInput": this.dsSearchInput
          },
          "on": {
            "searchInputChange": val => this.dsSearchInput = val
          }
        }, this.defaultScopeSlot(this.tab)]));
      case '$app':
        return h("a-tooltip", {
          "attrs": {
            "getPopupContainer": () => {
              var _this$windowRef4;
              return ((_this$windowRef4 = this.windowRef) === null || _this$windowRef4 === void 0 ? void 0 : _this$windowRef4.document.body) || window.document.body;
            }
          }
        }, [h("span", {
          "slot": "title"
        }, [" \u5728\u63A7\u5236\u53F0\u4E2D\u8C03\u8BD5 "]), h("span", {
          "class": "vue-select",
          "on": {
            "click": () => this.handleLog(this.currentScopeDataSource[this.tab], '$app')
          }
        }, ["Vue\u5B9E\u4F8B", h("a-icon", {
          "attrs": {
            "type": "bug",
            "theme": "twoTone",
            "twoToneColor": 'green'
          }
        })])]);
      default:
        return h(SearchableJsonView, _mergeJSXProps2([{
          "attrs": {
            "value": this.currentScopeDataSource[this.tab],
            "initKey": this.tab,
            "rootLevelKeys": [this.tab],
            "searchPlaceholder": "过滤数据",
            "searchInput": this.dsSearchInput
          },
          "on": {
            "searchInputChange": val => this.dsSearchInput = val
          }
        }, this.defaultScopeSlot(this.tab)]));
    }
  }
  handleTabChange({
    key
  }) {
    // eslint-disable-next-line prefer-destructuring
    this.tab = key;
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucd-devTool-layout-propPanel-dsDrawer"
    }, [h("div", {
      "directives": [{
        name: "show",
        value: this.dataSourceDrawerOpen
      }],
      "class": "resizer",
      "on": {
        "mousedown": this.startResize
      }
    }), h("a-collapse", {
      "attrs": {
        "expandIconPosition": "right",
        "accordion": true,
        "bordered": false
      },
      "model": {
        value: this.dataSourceDrawerOpen,
        callback: $$v => {
          this.dataSourceDrawerOpen = $$v;
        }
      }
    }, [h("a-collapse-panel", {
      "key": "dataSource",
      "attrs": {
        "header": "数据源"
      }
    }, [h("div", {
      "class": "ucd-devTool-layout-propPanel-dsDrawer-content",
      "style": this.style,
      "ref": "dsContent"
    }, [h("a-menu", {
      "attrs": {
        "selectedKeys": [this.tab],
        "mode": "horizontal",
        "getPopupContainer": () => {
          var _this$windowRef5;
          return ((_this$windowRef5 = this.windowRef) === null || _this$windowRef5 === void 0 ? void 0 : _this$windowRef5.document.body) || window.document.body;
        }
      },
      "on": {
        "select": this.handleTabChange
      },
      "class": "tab-header"
    }, [Object.keys(this.currentScopeDataSource).map(tab => this.currentScopeDataSource[tab] && h("a-menu-item", {
      "key": tab
    }, [" ", this.displayInfo[tab], " "]))]), this.tabContent])])])]);
  }
};
__decorate([Watch('height')], DatasourceDrawer.prototype, "handleHeightChange", null);
__decorate([Watch('displayInfo', {
  deep: true
})], DatasourceDrawer.prototype, "handleDisplayChange", null);
DatasourceDrawer = __decorate([Component({
  name: 'DatasourceDrawer'
})], DatasourceDrawer);
export default DatasourceDrawer;
//# sourceMappingURL=DataDrawer.js.map
